import type { VehicleListing } from '@/models/registry';
import { vehicleListingStore } from '@/models/stores';
import type { VEHICLE_LISTINGS_GROUPED_BY_PURCHASE_STATUS } from '@/models/types';

export const useGroupedVehicleList =
  (): VEHICLE_LISTINGS_GROUPED_BY_PURCHASE_STATUS => {
    return vehicleListingStore.groupedByPurchaseStatus;
  };

export const useAvailableVehicleList = (): VehicleListing[] => {
  return vehicleListingStore.availableVehicles;
};

export const usePurchaseInProgressVehicleList = (): VehicleListing[] => {
  return vehicleListingStore.purchaseInProgressVehicles;
};

export const useSoldVehicleList = (): VehicleListing[] => {
  return vehicleListingStore.soldVehicles;
};
